<template>
  <div id="brand-main-container">
	<!-- 네비게이션바 -->
	<!-- <div class="brand-nav"> 
		<ul>
			<li class="active"></li>
			<li></li>
			<li></li>
			<li></li>
			<li></li>
			<li></li>
			<li></li>
		</ul>
	</div> -->
	<!-- 1. [ WEB / MOBILE ] 헤더영역 ------------------------------------------------------------------>
	<!-- <div class="brand-header" :ref="'section_1'"> -->
	<div :class="headerVisible ? 'brand-header' : 'brand-header header-up'" :ref="'section_1'">
		<div class="brand-menu">
			<ul>
				<li><a>HighPro</a></li>
				<li><a>얼라이언스</a></li>
				<li><a>Blog</a></li>
				<li><a>커뮤니티</a></li>
			</ul>
		</div>
		<div class="m-menu-btn"><img src="/images/menu_open.png" alt="전체메뉴 열기" ></div>
		<!-- <div class="header-frame">
		</div> -->
	</div>


	<!-- 2. [ WEB / MOBILE ] 영상영역 ------------------------------------------------------------------>
	<div class="brand-video">
		<div class="brand-video-frame">
			<video :src="nowVideo" type="video/mp4" autoplay playsinline muted @ended="videoPlayer('next')" />
			<div class="video-cursor-frame">
				<div id="slide-btn" class="btn-prev" @click="btnClick('prev')">
					&lt;
				</div>
				<div id="slide-btn" class="btn-next" @click="btnClick('next')">
					&gt;
				</div>
			</div>
			<!-- [ MOBILE ] 동영상 라운드 처리 -->
			<div class="m-round-box1"></div>
		</div>
	</div>


	<!-- 3. 글자 스크롤 영역 ------------------------------------------------------------------>
	<!-- [ WEB ] -->
	<div class="brand-intro" :ref="'section_2'">
		<div class="brand-intro-frame">
			<!-- 글자 애니메이션 박스 -->
			<div class="round-box1" :ref="'round_box1'"></div>
			<div class="intro-box" :ref="'intro_box1'">
				<div class="intro-tit">IT<br/>Entertainment</div>
				<div class="intro-subtit">IT 프로젝트의 세상에는 과연 무엇이 있을까요?</div>
				<div class="intro-cont">
					일하는 즐거움, 성공하는 짜릿한 쾌감도 있습니다.<br/>
					하나 더!<br/>
					처음부터 끝까지, 당신 곁에 누군가가<br/>
					당신을 도와주기 위하여 존재한다는 새로운 사실입니다.<br/>
					누군가와 함께 하여 더 행복하고, 더 성공할 수 있다면,<br/>
					하이프로가 당신 곁에 있기 때문입니다.
				</div>
				<div class="intro-button">
					하이프로 바로가기
				</div>
			</div>

			<div class="round-box2" :ref="'round_box2'"></div>
			<div class="intro-box intro-box2" :ref="'intro_box2'">
				<div class="intro-tit">Great<br/>Pro</div>
				<div class="intro-subtit">프로 위의 프로-당신이 그레이트 프로입니다.</div>
				<div class="intro-cont">
					우리는 IT 프로페셔널리스트를 꿈꾸는 당신을 존경합니다.<br/>
					새로운 기술을 통해 모두가 만족하는 솔루션을 찾아내는 일은<br/>
					쉽지 않은 일이지만, 우리 모두의 행복을 크게 하는 일입니다.<br/>
					단순히 기술의 발휘에 그치지 않고,<br/>
					새로운 솔루션을 탄생시키는 사람.<br/>
					행복한 미래는 당신의 가슴과 두뇌,<br/>
					손끝에서 끊임없이 창조됩니다.<br/>
				</div>
				<div class="intro-button">
					하이프로 바로가기
				</div>
			</div>

			<div class="intro-box intro-box2" :ref="'intro_box3'">
				<div class="intro-tit">Pro<br/>Allience</div>
				<div class="intro-subtit">하이프로가 놀라운 ‘얼라이언스 혁명’을 시작합니다.</div>
				<div class="intro-cont">
					우리는 단순한 채용, 이직, 커리어 관리에 멈추지 않습니다.<br/>
					하이프로는 IT 프로와 프로젝트간의<br/>
					행복한 연합, 프로 얼라이언스를 통해<br/>
					지속가능한 성공의 협력체계를 구축합니다.<br/>
					전문성, 신뢰, 보증, 존경<br/>
					이 네 가지는 하이프로의 변하지 않는 원칙입니다.<br/>
				</div>
				<div class="intro-button">
					하이프로 바로가기
				</div>
			</div>

			<div class="round-box3" :ref="'round_box3'"></div>
			<div class="intro-box" :ref="'intro_box4'">
				<div class="intro-tit">Connect<br/>Value</div>
				<div class="intro-subtit">당신은 개발 전문가이고, 프리랜서이면서<br/>이직을 꿈꾸는 현역일 수 있습니다.</div>
				<div class="intro-cont">
					그러나,<br/>
					IT 프로 한 분 한 분은 그 존재 자체로 존경스러운 가치입니다.<br/>
					하이프로와 함께 하는 모든 기업과 프로젝트 역시 소중한 가치 그 자체입니다.<br/>
					하이프로는 가치와 가치를 연결합니다.<br/>
					가치와 가치가 만나 더 큰 가치, 그레이트 밸류가 탄생합니다.<br/>
				</div>
				<div class="intro-button">
					하이프로 바로가기
				</div>
			</div>
		</div>

	</div>

	<!-- [ MOBILE ] -->
	<div class="m-brand-intro">
		<div class="m-brand-intro-frame">
			<!-- 글자 애니메이션 박스 -->
			<div class="m-intro-box">
				<div class="m-intro-tit">IT<br/>Entertainment</div>
				<div class="m-intro-subtit">IT 프로젝트의 세상에는<br/>과연 무엇이 있을까요?</div>
				<div class="m-intro-cont">
					일하는 즐거움, 성공하는 짜릿한<br/>쾌감도 있습니다.<br/>
					하나 더!<br/>
					처음부터 끝까지, 당신 곁에 누군가가<br/>
					당신을 도와주기 위하여 존재한다는<br/>
					새로운 사실입니다.<br/>
					누군가와 함께 하여 더 행복하고,<br/>
					더 성공할 수 있다면,<br/>
					하이프로가 당신 곁에 있기 때문입니다.
				</div>
				<div class="m-intro-button">
					하이프로 바로가기
				</div>
			</div>

			<div class="m-round-box2"></div>

			<div class="m-intro-box">
				<div class="m-intro-tit">Great<br/>Pro</div>
				<div class="m-intro-subtit">프로 위의 프로<br/>당신이 그레이트 프로입니다.</div>
				<div class="m-intro-cont">
					우리는 IT 프로페셔널리스트를 꿈꾸는<br/>
					당신을 존경합니다.<br/>
					새로운 기술을 통해 모두가 만족하는<br/>
					솔루션을 찾아내는 일은<br/>
					쉽지 않은 일이지만,<br/>
					우리 모두의 행복을 크게 하는 일입니다.<br/>
					단순히 기술의 발휘에 그치지 않고,<br/>
					새로운 솔루션을 탄생시키는 사람.<br/>
					행복한 미래는 당신의 가슴과 두뇌,<br/>
					손끝에서 끊임없이 창조됩니다.<br/>
				</div>
				<div class="m-intro-button">
					하이프로 바로가기
				</div>
			</div>

			<div class="m-round-box3"></div>

			<div class="m-intro-box">
				<div class="m-intro-tit">Pro<br/>Allience</div>
				<div class="m-intro-subtit">하이프로가 놀라운<br/>‘얼라이언스 혁명’을<br/>시작합니다.</div>
				<div class="m-intro-cont">
					우리는 단순한 채용, 이직,<br/>
					커리어 관리에 멈추지 않습니다.<br/>
					하이프로는 IT 프로와 프로젝트간의<br/>
					행복한 연합, 프로 얼라이언스를 통해<br/>
					지속가능한 성공의<br/>
					협력체계를 구축합니다.<br/>
					전문성, 신뢰, 보증, 존경<br/>
					이 네 가지는 하이프로의<br/>변하지 않는 원칙입니다.<br/>
				</div>
				<div class="m-intro-button">
					하이프로 바로가기
				</div>
			</div>

			<div class="m-intro-box">
				<div class="m-intro-tit">Connect<br/>Value</div>
				<div class="m-intro-subtit">당신은 개발 전문가이고,<br/>프리랜서이면서<br/>이직을 꿈꾸는<br/>현역일 수 있습니다.</div>
				<div class="m-intro-cont">
					그러나,<br/>
					IT 프로 한 분 한 분은 그 존재 자체로<br/>
					존경스러운 가치입니다.<br/>
					하이프로와 함께 하는 모든 기업과<br/>
					프로젝트 역시 소중한 가치<br/>
					그 자체입니다.<br/>
					하이프로는 가치와 가치를 연결합니다.<br/>
					가치와 가치가 만나 더 큰 가치,<br/>
					그레이트 밸류가 탄생합니다.<br/>
				</div>
				<div class="m-intro-button">
					하이프로 바로가기
				</div>
			</div>

			<div class="m-round-box4"></div>

		</div>

	</div>


	<!-- 4. 하이프로 간단 소개 영역 ------------------------------------------------------------------>
	<!-- [ WEB ] -->
	<div class="brand-highpro-info" :ref="'section_3'">
		<div class="info-tit">대한민국 최초!<br/>금융IT 엔터테인먼트 플랫폼, 하이프로</div>
		<div class="info-frame">
			
			<div class="info-box">
				<div class="info-box-tit"><q class="num">100</q>명</div>
				<div class="info-box-cont">정예 금융IT 프로 얼라이언스<br/>회원수</div>
			</div>
			
			<div class="info-box">
				<div class="info-box-tit"><q class="num">12</q>개</div>
				<div class="info-box-cont">금융 그룹 얼라이언스<br/>고객 수</div>
			</div>

			<div class="info-box">
				<div class="info-box-tit"><q class="num">7</q>개</div>
				<div class="info-box-cont">초대형 금융IT<br/>연간 프로젝트 의뢰 수</div>
			</div>

			<div class="info-box">
				<div class="info-box-tit"><q class="num">100</q>%</div>
				<div class="info-box-cont">금융IT 프로젝트<br/>얼라이언스 만족 지수</div>
			</div>

		</div>
	</div>

	<!-- [ MOBILE ] -->
	<div class="m-brand-highpro-info">
		
		<div class="m-info-tit">대한민국 최초!<br/>금융IT 엔터테인먼트 플랫폼,<br/>하이프로</div>

		<div class="m-info-frame top">
			<div class="m-info-box mr-11">
				<div class="m-info-box-tit"><q class="num">100 </q>명</div>
				<div class="m-info-box-cont">정예 금융IT<br/>프로 얼라이언스<br/>회원수</div>
			</div>

			<hr class="m-verti-line mt-2"/>

			<div class="m-info-box">
				<div class="m-info-box-tit"><q class="num">12 </q>개</div>
				<div class="m-info-box-cont">금융 그룹<br/>얼라이언스<br/>고객 수</div>
			</div>
		</div>

		<hr class="m-verti-line mt-6"/>

		<div class="m-info-frame botm">
			<div class="m-info-box">
				<div class="m-info-box-tit"><q class="num">7 </q>개</div>
				<div class="m-info-box-cont">초대형 금융IT<br/>연간 프로젝트<br/>의뢰 수</div>
			</div>

			<div class="m-info-box">
				<div class="m-info-box-tit"><q class="num">100 </q>%</div>
				<div class="m-info-box-cont">금융IT 프로젝트<br/>얼라이언스<br/>만족 지수</div>
			</div>
		</div>

	</div>


	<!-- 5. 하이프로 포인트 영역 ------------------------------------------------------------------>
	<!-- [ WEB ] -->
	<div class="brand-point" :ref="'section_4'">
		<div class="point-tit">대한민국 최초!<br/>얼라이언스 그레이트 보상제</div>
		<div class="point-subtit">
			프로 위의 프로, 하이프로와 함께<br/>
			회원 가입부터 이력서 갱신까지 한 단계씩 도전해 보세요.<br/>
			하이프로의 그레이트 포인트는 포인트 그 이상의 가치가 있습니다.<br/>
		</div>
		<div class="point-cont-frame">
		
			<div class="point-box">
				<div class="point-box-tit">회원가입</div>
				<div class="point-box-cont">
					<p class="point">100,000</p>
					<p class="p-box">P</p>
				</div>
			</div>

			<div class="point-box">
				<div class="point-box-tit">이력서 등록</div>
				<div class="point-box-cont">
					<p class="point">100,000</p>
					<p class="p-box">P</p>
				</div>
			</div>

			<div class="point-box">
				<div class="point-box-tit">프로필 증빙서류 첨부</div>
				<div class="point-box-cont">
					<p class="point">100,000</p>
					<p class="p-box">P</p>
				</div>
			</div>

			<div class="point-box">
				<div class="point-box-tit">NCS 직무 자가평가</div>
				<div class="point-box-cont">
					<p class="point">50,000</p>
					<p class="p-box">P</p>
				</div>
			</div>

			<div class="point-box">
				<div class="point-box-tit">하이프로 인터뷰 완료</div>
				<div class="point-box-cont">
					<p class="point">50,000</p>
					<p class="p-box">P</p>
				</div>
			</div>

			<div class="point-box">
				<div class="point-box-tit">프로젝트 참여 확정 축하</div>
				<div class="point-box-cont">
					<p class="point">150,000</p>
					<p class="p-box">P</p>
				</div>
			</div>

			<div class="point-box">
				<div class="point-box-tit">이력서 갱신</div>
				<div class="point-box-cont">
					<p class="point">200,000</p>
					<p class="p-box">P</p>
				</div>
			</div>

		</div>
	</div>

	<!-- [ MOBILE ] -->
	<div class="m-brand-point">
		<div class="m-point-tit">대한민국 최초!<br/>얼라이언스 그레이트 보상제</div>
		<div class="m-point-subtit">
			프로 위의 프로, 하이프로와 함께<br/>
			회원 가입부터 이력서 갱신까지<br/>
			한 단계씩 도전해 보세요.<br/>
			하이프로의 그레이트 포인트는<br/>
			포인트 그 이상의 가치가 있습니다.<br/>
		</div>
		<div class="m-point-cont-frame">
		
			<div class="m-point-box">
				<div class="m-point-box-tit">회원가입</div>
				<div class="m-point-box-cont">
					<p class="point">100,000</p>
					<p class="m-p-box">P</p>
				</div>
			</div>

			<div class="m-point-box">
				<div class="m-point-box-tit">이력서 등록</div>
				<div class="m-point-box-cont">
					<p class="point">100,000</p>
					<p class="m-p-box">P</p>
				</div>
			</div>

			<div class="m-point-box">
				<div class="m-point-box-tit">프로필 증빙서류 첨부</div>
				<div class="m-point-box-cont">
					<p class="point">100,000</p>
					<p class="m-p-box">P</p>
				</div>
			</div>

			<div class="m-point-box">
				<div class="m-point-box-tit">NCS 직무 자가평가</div>
				<div class="m-point-box-cont">
					<p class="point">50,000</p>
					<p class="m-p-box">P</p>
				</div>
			</div>

			<div class="m-point-box">
				<div class="m-point-box-tit">하이프로 인터뷰 완료</div>
				<div class="m-point-box-cont">
					<p class="point">50,000</p>
					<p class="m-p-box">P</p>
				</div>
			</div>

			<div class="m-point-box">
				<div class="m-point-box-tit">프로젝트 참여 확정 축하</div>
				<div class="m-point-box-cont">
					<p class="point">150,000</p>
					<p class="m-p-box">P</p>
				</div>
			</div>

			<div class="m-point-box">
				<div class="m-point-box-tit">이력서 갱신</div>
				<div class="m-point-box-cont">
					<p class="point">200,000</p>
					<p class="m-p-box">P</p>
				</div>
			</div>

		</div>
	</div>


	<!-- 6. [ WEB / MOBILE ] 하이프로 블로그 영역 ------------------------------------------------------------------>
	<div class="brand-blog" :ref="'section_5'">
		<div class="blog-frame">
			<div class="blog-tit">하이프로 블로그</div>
			<div class="line" />
			<div class="blog-subtit">하이프로와 차 한잔 하세요.<br/>이런 저런IT 정보 콘텐츠도 만나고, 하이프로 소식도 전해 드립니다.</div>
			<div class="m-blog-subtit">하이프로와 차 한잔 하세요.<br/>이런 저런IT 정보 콘텐츠도 만나고,<br/>하이프로 소식도 전해 드립니다.</div>

			<div class="blog-img-frame">
				<div class="blog-card">
					<div class="card-img"><img /></div>
					<div class="card-text">AI 인재 어디 없나?<br/>IT 인재 확보가 금융사의 경쟁력으로 정착</div>
				</div>

				<div class="blog-card">
					<div class="card-img"><img /></div>
					<div class="card-text">AI 인재 어디 없나?<br/>IT 인재 확보가 금융사의 경쟁력으로 정착</div>
				</div>
			</div>
			
			<div class="blog-img-frame">
				<div class="blog-card">
					<div class="card-img"><img /></div>
					<div class="card-text">AI 인재 어디 없나?<br/>IT 인재 확보가 금융사의 경쟁력으로 정착</div>
				</div>

				<div class="blog-card">
					<div class="card-img"><img /></div>
					<div class="card-text">AI 인재 어디 없나?<br/>IT 인재 확보가 금융사의 경쟁력으로 정착</div>
				</div>
			</div>

		</div>
	</div>


	<!-- 7. [ WEB / MOBILE ] 하이프로 고객사 영역 ------------------------------------------------------------------>
	<div class="brand-partner" :ref="'section_6'">
		<div class="partner-frame">
			<div class="partner-tit">
				하이프로는 대한민국 탑티어 고객사와<br/>
				프로젝트 성공의 경험을 확인하고 있습니다.
			</div>
			<div class="m-partner-tit">
				하이프로는<br/>
				대한민국 탑티어 고객사와<br/>
				프로젝트 성공의 경험을<br/>
				확인하고 있습니다.
			</div>
			<div class="line" />
			<div class="partner-box">
				<img src="/images/partner.png">
			</div>
		</div>
	</div>

	<!-- 8. footer ------------------------------------------------------------------>
	<!-- [ WEB ] -->
	<div class="brand-footer" :ref="'section_7'">
		<div class="footer-frame">
			<div class="footer-left">
				<p>Copyright ⓒ 2021 Pro&Solution All rights reserved.</p>
			</div>
			<div class="footer-right">
				<div class="footer-company">
					<ul>
						<li>회사소개</li>
						<li>서비스 이용약관</li>
						<li>개인정보 보호정책</li>
					</ul>
				</div>
				<div class="footer-sub-frame">
					<div class="footer-text">
					고객센터 : 02 · 780 · 3800  [ 상담시간 ] 월 ~금 10:00 ~ 18:00<br/>
					이메일 : highpro@pron.co.kr
					</div>
					<div class="footer-imgbox">
						<img src="/images/insta_ico.png" />
						<img src="/images/facebook_ico.png" />
						<img src="/images/blog_ico.png" />
					</div>
				</div>
			</div>
	    </div>
	</div>

	<!-- [ MOBILE ] -->
	<div class="m-brand-footer">
		<div class="m-footer-frame">
			<div class="m-footer-logo">
			</div>
			<div class="m-footer-company">
				<div>회사소개</div>
				<div>서비스 이용약관</div>
				<div>개인정보 보호정책</div>
			</div>
			<div class="m-footer-imgbox">
				<img src="/images/insta_ico.png" />
				<img src="/images/facebook_ico.png" />
				<img src="/images/blog_ico.png" />
			</div>
			<div class="m-footer-sub-frame">
				<div class="m-footer-text">
					고객센터 : 02 · 780 · 3800<br/>
					[ 상담시간 ] 월 ~금 10:00 ~ 18:00<br/>
					이메일 : highpro@pron.co.kr<br/>
					<p>Copyright ⓒ 2021 Pro&Solution All rights reserved.</p>
				</div>
			</div>
	    </div>
	</div>

  </div>
</template>

<script>
import {gsap, CSSPlugin, ScrollTrigger} from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSPlugin);

export default {
    components: {
        
    },
	data() {
		return {
		   videoList : ['test1.mp4', 'test2.mp4', 'test3.mp4'],
		   nowVideo : '',
		   videoIdx : 0,

		   lastScrollTop : 0,
		   headerVisible : true, // 스크롤에 따른 헤더 노출여부
		}
	},
	beforeMount(){
	},
    created() {
    },

	mounted : function() {
		this.scrollAnimation();
		this.videoPlayer('start');

		window.addEventListener('scroll', this.onScroll);
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
	},

	methods: {
		onScroll () { // 스크롤에 따른 헤더 노출
			if(screen.width < 1024){
				const delta = 15;
				var tmpLastScrollTOP = this.lastScrollTop;
				var curScrollTOP = document.documentElement.scrollTop; // 현재 스크롤 위치
				
				if(Math.abs(tmpLastScrollTOP - curScrollTOP) <= delta) return;

				if((curScrollTOP > 150) && (curScrollTOP > tmpLastScrollTOP) && (tmpLastScrollTOP > 0)) {
					this.headerVisible = false;
				} else{
					this.headerVisible = true;
				}

				this.lastScrollTop = curScrollTOP;
			}
		},
		videoPlayer(val) {
			switch(val) {
				case 'next' : 
					if(this.videoIdx == this.videoList.length-1) {
						this.videoIdx = 0;	
					} else {
						this.videoIdx++;
					}
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
					break;
				case 'prev' :
					if(this.videoIdx == 0) {
						this.videoIdx = this.videoList.length-1;	
					} else {
						this.videoIdx--;
					}
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
					break;
				default : 
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
				}
		},
		btnClick(val) {
			if(val == 'next') {
				this.videoPlayer('next');
			} else if(val == 'prev') {
				this.videoPlayer('prev');
			}
		},
		scrollAnimation(){
			// 작업중
			const $scrollBox1 = this.$refs.intro_box1;
			const $roundBox1 = this.$refs.round_box1;
			const $roundBox2 = this.$refs.round_box2;
			const intro_box2 = gsap.utils.toArray('.intro-box2');
			const $roundBox3 = this.$refs.round_box3;
			const $scrollBox2 = this.$refs.intro_box4;
			const p_box = gsap.utils.toArray('.p-box');
			
			gsap.fromTo(
				$scrollBox1, // 이벤트 적용 위치
				{ x: 1200 }, // 시작위치
				{ 
					x : 0,
					scrollTrigger : {
						trigger : $scrollBox1,
						start : "top bottom",
						end : "top top",
						// markers : true,
						scrub : true,
					},
				} // 종료 위치
			);

			gsap.fromTo(
				$roundBox1,
				{ x : 0 },
				{ 
					x : -1200,
					scrollTrigger : {
						trigger : $roundBox1,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			)

			gsap.fromTo(
				$roundBox2,
				{ x : 0 },
				{ 
					x : 1300,
					scrollTrigger : {
						trigger : $roundBox2,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			)

			intro_box2.forEach(box => {
				gsap.fromTo(
					box, 
					{ x : 1200 , opacity : 0},
					{
						x : 0,
						opacity : 1,
						scrollTrigger : {
							trigger : box,
							start : "top 80%",
							end : "90% bottom",
							scrub : true,
							// markers : true,
						}
					}
					);
			});

			gsap.fromTo(
				$roundBox3,
				{ x : 0 },
				{ 
					x : -1500,
					scrollTrigger : {
						trigger : $roundBox3,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			);

			gsap.fromTo(
				$scrollBox2, // 이벤트 적용 위치
				{ x: -1200, opacity : 0 }, // 시작위치
				{ 
					x : 0,
					opacity : 1,
					scrollTrigger : {
						trigger : $scrollBox2,
						start : "top bottom",
						end : "70% 80%",
						// markers : true,
						scrub : true,
					},
				} // 종료 위치
			);

			p_box.forEach(box => {
				// gsap.from( box, { 
				// 		scrollTrigger : box,
				// 		duration : 1,
				// 		autoAlpha : 0,
				// 		scale : 1.5,
				// 		width : 0,
				// 		start : 'top 90%',
				// 		// end : "top 90%",
				// 		// stagger : 0.07,
				// 		// markers : true,
				// 		// rotation : -80,
				// 		// skew: 90,
				// 		// ease : 'power1.easeNone'
				// 	}
				// );
				let box_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : box,
						start : 'top 95%',
						// markers : true,
					}
				});
				box_timeLine.from(box, {
						duration : 1,
						autoAlpha : 0,
						scale : 1.5,
						width : 0,
				});
			});


			/********** [ MOBILE ] **********/
			 /* 3. 텍스트 영역 */
			const m_intro_box_list = gsap.utils.toArray('.m-intro-box');

			m_intro_box_list.forEach(element => {
				const mIntroBoxList_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : element,
						start : "top 95%",
						// markers : true,
						
					}
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-tit'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-subtit'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-cont'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-button'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});

			});

			/* 5. 포인트 영역 */
			const m_point_box_list = gsap.utils.toArray('.m-point-box');

			m_point_box_list.forEach(element => {
				const mPointBoxList_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : element,
						start : "top 95%",
						// markers : true,
					}
				});
				mPointBoxList_timeLine.from(element.querySelector('.m-point-box-tit'), {
					y: 100,
					opacity: 0, 
					duration: 0.4
				});
				mPointBoxList_timeLine.from(element.querySelector('.m-point-box-cont'), {
					y: 100,
					opacity: 0, 
					duration: 0.4
				});
			});
			
		}

	},
};
</script>